import { AppState } from '../root.reducer';

export const isSavedCompanyLoadingSelector = (state: AppState) => state.savedCompany.isSavedCompanyLoading;

export const savedCompanySelector = (state: AppState) => state.savedCompany.savedCompany;

export const discountSelector = (state: AppState) => state.savedCompany.discount;